
import ValidatorContext from "formvalidation/FormContext";
import { useValidators } from "formvalidation/hooks";
import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import { SectionTemplate } from "./SectionTemplate";
import { EditNewSection } from "./types";

type LocalFormSectionTemplateProps = {
  onSuccess: () => void;
  sections: Array<EditNewSection>;
  saveButtonLabel?: string;
  saveButtonDisabled?: boolean;
}

export const LocalFormSectionTemplate = (props: LocalFormSectionTemplateProps) => {
  const { onSuccess, sections } = props;
  const [isLoading, setIsLoading] = useState(false);

  const validators = useValidators();

  const onSubmit = async () => {
    if (isLoading) return;

    setIsLoading(true);
    const validatorResult = await validators.validateAll();

    if (validatorResult.hasErrors) {
      setIsLoading(false);
      return;
    }

    onSuccess();
  }

  const mappedSections = sections.map((section) => {
    if (section.type === "custom") {
      return section;
    }

    return {
      ...section,
      fields: section.fields.map((field) => ({
        ...field,
        isEmpty: false,
        render: field.renderEditNew,
        inPageEdit: undefined,
      })),
    }
  });

  const Footer = () => <div className="flex">
    <div className="grow1" />
    <Button
      primary
      type="submit"
      loading={isLoading}
      disabled={isLoading || props.saveButtonDisabled}
    >
      {props.saveButtonLabel || RESX.Buttons.btnSave}
    </Button>
  </div>

  return <ValidatorContext settings={validators.validatorSettings}>
    <form
      className="flex-column gap grow1"
      // Lets the form shrink inside a height-limited parent so only the sections scroll
      style={{ minHeight: 0 }}
      onSubmit={(e) => {
        e.preventDefault();

        // Stop propagation because we can have a form in a form (e.g. form > modal > form)
        e.stopPropagation();
        onSubmit();
      }}>
      <div className="grow1 scrollbox-auto">
        <SectionTemplate
          isInPageEditable={false}
          noPanels
          compact
          sections={mappedSections}
        />
      </div>
      <Footer />
    </form>
  </ValidatorContext>
}